import axios from 'axios';
require('../../static/config');
const apiUrl = config.apiUrl;
const _axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    'addons': 'bingo',
    'Accept': 'application/json, text/javascript, */*; q=0.01'
  }
});

export default {
  //首页推荐
  reqRecommendList(data) {
    return _axios.get(apiUrl + 'api/page/reqRecommendList', data);
  },
  //首页案例分类推荐
  reqCompanyCaseTypeListIndex(data) {
    return _axios.get(apiUrl + 'api/page/reqCompanyCaseTypeListIndex', data);
  },
  //首页产品分类推荐
  reqProductTypeListIndex(data) {
    return _axios.get(apiUrl + 'api/page/reqProductTypeListIndex', data);
  },
  //公司信息设置
  reqCompanyInfo(data) {
    return _axios.get(apiUrl + 'api/page/reqCompanyInfo', data);
  },
  //产品分类列表
  reqProductTypeList(data) {
    return _axios.get(apiUrl + 'api/page/reqProductTypeList', data);
  },
  //产品列表
  reqProductList(data) {
    return _axios.get(apiUrl + 'api/page/reqProductList', data);
  },
  //产品详情
  reqProductDetail(data) {
    return _axios.get(apiUrl + 'api/page/reqProductDetail', data);
  },
  //案例分类列表
  reqCompanyCaseTypeList(data) {
    return _axios.get(apiUrl + 'api/page/reqCompanyCaseTypeList', data);
  },
  //案例列表
  reqCompanyCaseList(data) {
    return _axios.get(apiUrl + 'api/page/reqCompanyCaseList', data);
  },
  //案例详情
  reqCompanyCaseDetail(data) {
    return _axios.get(apiUrl + 'api/page/reqCompanyCaseDetail', data);
  },
  //新闻列表
  reqNewsList(data) {
    return _axios.get(apiUrl + 'api/page/reqNewsList', data);
  },
  //新闻分类列表
  reqNewsTypeList(data) {
    return _axios.get(apiUrl + 'api/page/reqNewTypeList', data);
  },
  //新闻详情
  reqNewsDetail(data) {
    return _axios.get(apiUrl + 'api/page/reqNewsDetail', data);
  },

  //展馆列表
  reqPavilionList(data) {
    return _axios.get(apiUrl + 'api/page/reqExhibitionList', data);
  },

  //展馆详情
  reqPavilionDetail(data) {
    return _axios.get(apiUrl + 'api/page/reqExhibitionDetail', data);
  },

  //招聘列表
  recruit(data) {
    return _axios.get(apiUrl + 'api/page/recruit', data);
  },
  //公司历程列表
  reqCompanyIntro(data) {
    return _axios.get(apiUrl + 'api/page/reqCompanyIntro', data);
  },
  //点击量增加
  //入参：typeId 1.新闻，2.案例,3.产品  id
  clickNumPlus(data) {
    return _axios.get(apiUrl + 'api/page/clickNumPlus', data);
  },
  //留言表单
  leaveMessage(data) {
    return _axios.get(apiUrl + 'api/page/leaveMessage', data);
  },
  //招聘表单
  application(data) {
    return _axios.post(apiUrl + 'api/page/application', data);
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js